<template>
  <div class="py-6">
    <StarCarousel v-if="stars && stars.length > 0" :stars="stars" />
  </div>
</template>

<script>
import StarCarousel from "@/components/UI/Stars/StarCarousel";
import axios from "axios";
export default {
  name: "FeaturedStars",
  data() {
    return {
      stars: null,
    };
  },
  components: {
    StarCarousel,
  },
  mounted() {
    this.getStars();
  },
  methods: {
    getStars() {
      axios
        .get("/stars/top")
        .then((response) => {
          this.stars = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
</style>